module.exports = __webpack_public_path__ + "static/media/refunds.1fc05b90.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/resources/refunds.jpg
// module id = 3478
// module chunks = 0